import { forwardRef } from "react";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useLanguageStore } from "@/stores/language";

interface CTASectionProps {
  onViewAllPacksClick: () => void;
}

export const CTASection = forwardRef<HTMLElement, CTASectionProps>(
  ({ onViewAllPacksClick }, ref) => {
    const { t } = useLanguageStore();

    return (
      <section ref={ref} className="py-32 md:py-48 relative overflow-hidden">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h2
              className="text-4xl md:text-6xl lg:text-7xl font-bold tracking-tighter mb-8 css-fade-in-up"
            >
              {t(
                "Ready to Create?",
                "¿Listo para Crear?"
              )}
            </h2>
            
            <p
              className="text-lg md:text-xl text-muted-foreground mb-12 max-w-2xl mx-auto css-fade-in-up"
              style={{ '--animation-delay': '100ms' } as React.CSSProperties}
            >
              {t(
                "Start generating professional fashion imagery today with our curated AI prompt collections.",
                "Comienza a generar imágenes de moda profesionales hoy con nuestras colecciones de prompts de IA curadas."
              )}
            </p>
            
            <div
              className="css-fade-in-up"
              style={{ '--animation-delay': '200ms' } as React.CSSProperties}
            >
              <Button
                size="lg"
                onClick={onViewAllPacksClick}
                className="group text-base font-body px-8"
              >
                {t("View All Collections", "Ver Todas las Colecciones")}
                <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
              </Button>
            </div>
          </div>
        </div>
        
        {/* Decorative elements */}
        <div className="absolute inset-0 -z-10">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-accent/5 rounded-full blur-3xl" />
        </div>
      </section>
    );
  }
);

CTASection.displayName = "CTASection";

export default CTASection;
